import 'vscode/vscode/vs/nls';
import 'vscode/vscode/vs/base/common/network';
import 'vscode/vscode/vs/base/common/path';
import 'vscode/vscode/vs/base/common/process';
import 'vscode/vscode/vs/base/common/resources';
import 'vscode/vscode/vs/base/common/platform';

const EXTENSION_IDENTIFIER_WITH_LOG_REGEX = /^([^.]+\..+)[:=](.+)$/;

export { EXTENSION_IDENTIFIER_WITH_LOG_REGEX };
